import { AxiosResponse } from "axios";
import { ApiResponse } from "../common/type";
import axiosClient from "./axiosClient";

const commentApi = {
    createComment: async (data: any): Promise<ApiResponse<any>> => {
        return axiosClient.post(`/comments`, data, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },
    getAllComments: async (params: any): Promise<
        AxiosResponse<any>
    > => {
        return axiosClient.get<ApiResponse<any>>(
            '/comments',
            { params }
        );
    },
    getRepliesOfComment: async (id: number): Promise<
        AxiosResponse<any>
    > => {
        return axiosClient.get<ApiResponse<any>>(
            `/comments/${id}/replies`,
        );
    },
};

export default commentApi;
